// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AcceptDesignUpdatesMutationVariables = Types.Exact<{
  input: Types.AcceptDesignPackageUpdatesInput;
}>;


export type AcceptDesignUpdatesMutation = { __typename?: 'Mutation', acceptDesignPackageUpdates: { __typename?: 'SaveDesignPackageUpdatesResult', designPackage: { __typename?: 'DesignPackage', id: string, name: string, copyInProgress: boolean, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
            | { __typename?: 'ReadyPlan', id: string, name: string }
            | { __typename?: 'PlanPackage', id: string, name: string }
            | { __typename?: 'DesignPackage', id: string, name: string }
            | { __typename?: 'ProductOffering', id: string, name: string }
          , tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } } };

export type DesignUpdatesAvailable_PlanUpdateFragment = { __typename?: 'DesignPackagePlanUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
    , tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } };

export type DesignUpdatesAvailable_ReadyPlanLocationVersionFragment = { __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string };

export const DesignUpdatesAvailable_ReadyPlanLocationVersionFragmentDoc = gql`
    fragment DesignUpdatesAvailable_ReadyPlanLocationVersion on ReadyPlanLocationVersion {
  id
  changeType
}
    `;
export const DesignUpdatesAvailable_PlanUpdateFragmentDoc = gql`
    fragment DesignUpdatesAvailable_PlanUpdate on DesignPackagePlanUpdate {
  id
  createdAt
  planVersion {
    id
    version
    versionNotes
    readyPlan {
      id
      name
    }
    tliVersions {
      id
      changeType
      identity {
        id
        isPlaceholderMaterial
      }
    }
    rplVersions {
      ...DesignUpdatesAvailable_ReadyPlanLocationVersion
    }
  }
}
    ${DesignUpdatesAvailable_ReadyPlanLocationVersionFragmentDoc}`;
export const AcceptDesignUpdatesDocument = gql`
    mutation AcceptDesignUpdates($input: AcceptDesignPackageUpdatesInput!) {
  acceptDesignPackageUpdates(input: $input) {
    designPackage {
      id
      name
      copyInProgress
      availableUpdates {
        ...DesignUpdatesAvailable_PlanUpdate
      }
      aggregateDraft {
        id
      }
    }
  }
}
    ${DesignUpdatesAvailable_PlanUpdateFragmentDoc}`;
export type AcceptDesignUpdatesMutationFn = Apollo.MutationFunction<AcceptDesignUpdatesMutation, AcceptDesignUpdatesMutationVariables>;

/**
 * __useAcceptDesignUpdatesMutation__
 *
 * To run a mutation, you first call `useAcceptDesignUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDesignUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDesignUpdatesMutation, { data, loading, error }] = useAcceptDesignUpdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptDesignUpdatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptDesignUpdatesMutation, AcceptDesignUpdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptDesignUpdatesMutation, AcceptDesignUpdatesMutationVariables>(AcceptDesignUpdatesDocument, options);
      }
export type AcceptDesignUpdatesMutationHookResult = ReturnType<typeof useAcceptDesignUpdatesMutation>;
export type AcceptDesignUpdatesMutationResult = Apollo.MutationResult<AcceptDesignUpdatesMutation>;
export type AcceptDesignUpdatesMutationOptions = Apollo.BaseMutationOptions<AcceptDesignUpdatesMutation, AcceptDesignUpdatesMutationVariables>;